var map = {
	"./Group 22302.png": 1016,
	"./avatar-christmas.webp": 1017,
	"./bottom-bg-christmas.webp": 1018,
	"./btn-active.png": 1019,
	"./content-deco-1.webp": 1020,
	"./content-deco-2.webp": 1021,
	"./content-deco-3.webp": 1022,
	"./content-deco-4.webp": 1023,
	"./deco-3.webp": 1024,
	"./deposit-icon.webp": 1025,
	"./home-icon-active.webp": 1026,
	"./home-icon.webp": 1027,
	"./live-icon-active.webp": 1028,
	"./live-icon.webp": 1029,
	"./master-bg.jpg": 1030,
	"./me-icon-active.webp": 1031,
	"./me-icon.webp": 1032,
	"./platform.png": 1033,
	"./platform.webp": 1034,
	"./promos-icon-active.webp": 1035,
	"./promos-icon.webp": 1036,
	"./promos.webp": 1037,
	"./service-christmas.webp": 1038,
	"./snowman.webp": 1039,
	"./sponsor-icon-active.webp": 1040,
	"./sponsor-icon.webp": 1041,
	"./title-deco-left.webp": 1042,
	"./title-deco-right.webp": 1043,
	"./tree.webp": 1044,
	"./vip-icon.webp": 1045,
	"./vip.webp": 1046,
	"./withdraw-icon.webp": 1047,
	"./wwr-img.webp": 1048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;